 const setting = {
    //简写
    abbreviation: 'vab',
    //不经过token校验的路由
    routesWhiteList: [],
    //加载时显示文字
    loadingText: '正在加载中...',
    //token存储位置localStorage sessionStorage
    storage: 'localStorage',
     //消息框消失时间
    messageDuration: 3000,
    //最长请求时间
    requestTimeout: 5000,
    //操作正常code，支持String、Array、int多种类型
    successCode: [200, 0],
    //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
    title: 'admin-pro',
    //需要加loading层的请求，防止重复提交
    debounce: ['edit','add','import'],
  }
  module.exports = setting
  